export default "__VITE_ASSET__CLFwY00V__"